import { Field, ID, InputType, Int } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { WorkOrder } from '../WorkOrder'
import type { IAction } from '../../action/IAction'

@InputType()
export class SortWorkOrderTasksArgs extends ActionArgs {
  @Field(() => ID)
  workOrderId: string

  @Field(() => ID)
  taskId: string

  @Field(() => Int)
  sortIndex: number
}

export interface ISortWorkOrderTasks extends IAction<WorkOrder, SortWorkOrderTasksArgs> {}
